import {Injectable} from '@angular/core';
import {WizardNestedFormService} from '../abstract/wizard-nested-form-service';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {WizardFormEventsService} from '../wizard-form-events.service';
import {ActivatedRoute} from '@angular/router';
import {LaboratoryNamespace} from '@namespaces/laboratory.namespace';
import ResponsibleStaffFieldType = LaboratoryNamespace.ResponsibleStaffFieldType;
import ResponsibleStaffValue = LaboratoryNamespace.ResponsibleStaffValue;
import {UploadedFile} from '@interfaces/file.interface';
import ResponsibleStaffType = LaboratoryNamespace.ResponsibleStaffType;
import {requiredWithMessage} from '@helpers/validators/frontendRequired';

interface ResponsibleValue {
    label: string;
    type: ResponsibleStaffType;
    control: FormControl;
    specialist: {
        name: string;
        job: string;
        photo: UploadedFile;
    };
}


@Injectable()
export class ResponsibleStaffService extends WizardNestedFormService {
    form = this.fb.group({
        _touched: [false, Validators.requiredTrue],
    });

    public staff: ResponsibleStaffValue[] = [];
    public types: ResponsibleStaffFieldType[] = [];

    public value: ResponsibleValue[] = [];

    constructor(
        private fb: FormBuilder,
        private wizardFormEventsService: WizardFormEventsService,
        private route: ActivatedRoute,
    ) {
        super();
    }

    init() {
        this.types = this.route.snapshot.data.responsibleStaffTypes || [];
        this.staff = this.route.snapshot.data.responsibleStaff || [];

        this.setValuePreview();

        this.wizardFormEventsService.isRk$.pipe(
            takeUntil(this.destroyed$)
        ).subscribe((isRk) => {
            this.isRkChangeHandle(isRk);
        });
    }

    restoreValidators() {

    }

    private setValuePreview() {
        this.value = this.types.map((type): ResponsibleValue => {
            const current = this.staff.find(s => s.type_staff === type.type_staff);

            let specialist = null;

            if (current && current.specialist_id) {
                specialist = {
                    name: current.full_name,
                    job: current.job_title,
                    photo: current.photo,
                };
            }

            const control = this.fb.control(current && current.specialist_id || null,
                requiredWithMessage('Ответственный должен быть обязательно назначен')
            );

            this.form.setControl(type.type_staff, control);

            return {
                label: type.title,
                control: control,
                type: type.type_staff,
                specialist: specialist,
            };
        });
    }

    private isRkChangeHandle(isRk: boolean): void {
        const rkControl = this.form.get(ResponsibleStaffType.rk);
        const iiiControl = this.form.get(ResponsibleStaffType.iii);

        if (isRk) {
            rkControl.enable();
            iiiControl.enable();
        } else {
            rkControl.disable();
            iiiControl.disable();
        }
    }
}
